export enum SunlabsCaseType {
  KEYBOARDCASE = "KEYBOARDCASE",
  LID = "LID",
  RACK_DOUBLE_DOOR = "RACK_DOUBLE_DOOR",
  RACK_SINGLE_DOOR = "RACK_SINGLE_DOOR",
  SUITCASE = "SUITCASE",
  TRUNK = "TRUNK",
}
